import React, { useState, useEffect } from "react";
import { negativeNumberStringValidation } from "../Utils/validation";
import { Tooltip } from "@mui/material";

function InsideTextBox(props) {
  const {
    label,
    name,
    yearName,
    monthName,
    handleChange,
    onBlur,
    validation,
    callBack,
    items,
    view,
  } = props;

  const [yearMonth, setYearMonth] = useState<string[]>(
    ["y", "m"].map((item) => item)
  );

  let names = [yearName, monthName];

  const [error, setError] = useState([]);

  const onBlurEnd = (event) => {
    // if (!error.includes(event.target.name) && event.target.value.trim().length !== 0) {
    //   onBlur(event)
    // }
  };

  const validate =
    name === "ivf" ||
    name === "icsi" ||
    name === "iui" ||
    name === "miscarriages";

  const handleChangeEnd = (event) => {
    let errorDublicate = [...error];

    if (
      validation === "year" ||
      validation === "month" ||
      validation === "carriage"
    ) {
      if (event.target.value.trim().length !== 0)
        if (!negativeNumberStringValidation(event.target.value)) {
          errorDublicate = [...errorDublicate, event.target.name];
        } else {
          errorDublicate = errorDublicate.filter(
            (item) => item !== event.target.name
          );
        }
    }
    setError(errorDublicate);
    handleChange(event, !errorDublicate.includes(event.target.name));
  };

  const truncateLabel = (labelText, maxLength = 12) => {
    if (labelText.length > maxLength) {
      return `${labelText.substring(0, maxLength)}...`;
    }
    return labelText;
  };

  return (
    <>
      <span className="det-label">
        <Tooltip title={label} arrow>
          <span className="cursor-pointer">{truncateLabel(label)}</span>
        </Tooltip>
      </span>
      {/* <input type="text" value={data?.num +data?.y+ "y" +data?.m+ "m"} name={name} onChange={handleChange}/> */}
      <div className="Inside-Box me-4">
        <span>
          {yearMonth.map((item, index) => (
            <>
              <input
                type="text"
                className={`inside-Text ${
                  error.includes(names[index]) && "errorAlert"
                }`}
                value={props[names[index]]}
                name={names[index]}
                onChange={handleChangeEnd}
                onBlur={onBlurEnd}
                maxLength={2}
                disabled={view}
              />
              {item}
            </>
          ))}
        </span>
      </div>
      <input
        defaultValue={0}
        type="number"
        disabled={view}
        {...(validate
          ? {
              onInput: (e) => {
                e.target["value"] = Math.abs(e.target["value"]);
                let value = parseInt(e.target["value"]);
                if (value > 100) {
                  value = 100;
                } else if (isNaN(value)) {
                  value = 0;
                }
                e.target["value"] = value;
              },
            }
          : {})}
        value={props[name]}
        name={name}
        min={0}
        onChange={handleChangeEnd}
        onBlur={onBlur}
        className={`number-custom me-1`}
      />
    </>
  );
}

export default React.memo(InsideTextBox);
